import React, { useState, useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Award, ShieldCheck, ThumbsUp, Sparkles, ArrowRight } from 'lucide-react'
import LightboxGallery from '../components/LightboxGallery'
import BeforeAfterSlider from '../components/BeforeAfterSlider'

// Comprehensive list of all high-quality project images from our asset library
const ALL_ASSET_IMAGES = [
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/villys-2015-103-768x1024_1.jpg",
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/villys-2015-105-768x1024_1.jpg",
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/1fec9621-01fc-4c1d-b2fb-740aa2ee5a1a.jpeg", // image00001
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/dc061898-b483-4fda-9690-6e621c67b24b.jpeg", // image00002
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/31d88a64-184e-4204-b317-ebd41ea4edde.jpeg", // image00007
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/37580eae-d67a-442c-bb21-2ad4d662a80d.jpeg", // image00008
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/de8e7931-3d72-447f-9265-51526341fce7.jpeg", // image00009
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/facade.jpg",
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/facademaling.jpg",
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/64410012-dcaa-40af-a58c-df5091bd0c59.png",  // image00010
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/123da160-92ed-420f-b60b-5a174ae8a5f3.png",  // image00011
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/17045862-4f35-490a-91fd-3f00fa8be297.jpeg", // image00013
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/d142c128-4133-4307-a6d3-d23c7b9a7ce7.jpeg", // image00014
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/7ad70890-421f-4462-9be6-ff81da2bda37.jpeg", // image00015
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/3073aa37-21fb-409d-8135-709df6259f90.jpeg", // image00016
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/9ffac026-6b24-4cce-9dc6-dce86789ca2e.jpeg", // image00012
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/f3517ae6-43d8-433f-aa89-d1fc1ddd2762.jpeg", // image00017
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/05819e56-de71-4634-83f6-601b6e24fc89.jpeg", // image00018
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/a700de9a-376f-40eb-8d9a-1bb4d8a2058f.jpeg", // image00019
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/8d7e02f1-9ce4-48ff-8a27-011d8dcadd09.jpeg", // image00020
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/ff7e2047-6017-4c8c-92b7-e32ddd4e5d5c.jpeg", // image00021
  "https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/b8e39e69-f00a-4bfb-8620-29ca62cdd838.jpeg"  // image00022
]

// Curated Before & After pairs
const BEFORE_AFTER_PAIRS = [
  {
    id: 'gulvbehandling',
    title: 'Professionel gulvbehandling',
    description: 'Se den fantastiske forvandling af trægulvet efter professionel slibning og efterfølgende lakering, der bringer gløden og slidstyrken tilbage.',
    before: 'https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/1fec9621-01fc-4c1d-b2fb-740aa2ee5a1a.jpeg', // image00001
    after: 'https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/dc061898-b483-4fda-9690-6e621c67b24b.jpeg', // image00002
    beforeLabel: 'Før',
    afterLabel: 'Efter'
  },
  {
    id: 'behandling-af-terrasse',
    title: 'Behandling af terrasse',
    description: 'Se den store forskel før og efter en professionel rensning og oliebehandling af en træterrasse.',
    before: 'https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/64410012-dcaa-40af-a58c-df5091bd0c59.png', // image00010
    after: 'https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/123da160-92ed-420f-b60b-5a174ae8a5f3.png', // image00011
    beforeLabel: 'Før',
    afterLabel: 'Efter'
  }
]

// Mapping of UUIDs to their canonical filenames to identify duplicates
const UUID_TO_CANONICAL = {
  '1fec9621-01fc-4c1d-b2fb-740aa2ee5a1a': 'image00001',
  'dc061898-b483-4fda-9690-6e621c67b24b': 'image00002',
  '31d88a64-184e-4204-b317-ebd41ea4edde': 'image00007',
  '37580eae-d67a-442c-bb21-2ad4d662a80d': 'image00008',
  'de8e7931-3d72-447f-9265-51526341fce7': 'image00009',
  '64410012-dcaa-40af-a58c-df5091bd0c59': 'image00010',
  '123da160-92ed-420f-b60b-5a174ae8a5f3': 'image00011',
  '9ffac026-6b24-4cce-9dc6-dce86789ca2e': 'image00012',
  '17045862-4f35-490a-91fd-3f00fa8be297': 'image00013',
  'd142c128-4133-4307-a6d3-d23c7b9a7ce7': 'image00014',
  '7ad70890-421f-4462-9be6-ff81da2bda37': 'image00015',
  '3073aa37-21fb-409d-8135-709df6259f90': 'image00016',
  'f3517ae6-43d8-433f-aa89-d1fc1ddd2762': 'image00017',
  '05819e56-de71-4634-83f6-601b6e24fc89': 'image00018',
  'a700de9a-376f-40eb-8d9a-1bb4d8a2058f': 'image00019',
  '8d7e02f1-9ce4-48ff-8a27-011d8dcadd09': 'image00020',
  'ff7e2047-6017-4c8c-92b7-e32ddd4e5d5c': 'image00021',
  'b8e39e69-f00a-4bfb-8620-29ca62cdd838': 'image00022',
}

// Extract a canonical key from any image URL to identify duplicates
function getCanonicalKey(url) {
  if (!url) return ''
  const parts = url.split('/')
  const filename = parts[parts.length - 1]
  if (!filename) return url

  const dotIndex = filename.lastIndexOf('.')
  if (dotIndex === -1) return filename
  let name = filename.substring(0, dotIndex)
  const ext = filename.substring(dotIndex).toLowerCase()

  // Strip trailing suffixes like _1, _2, _3, _4
  name = name.replace(/_\d+$/, '')

  // Map UUIDs to their canonical names if known
  if (UUID_TO_CANONICAL[name]) {
    name = UUID_TO_CANONICAL[name]
  }

  return `${name}${ext}`.toLowerCase()
}

// Deduplicate an array of image URLs based on their canonical keys
function deduplicateImages(imagesArray) {
  if (!imagesArray || !Array.isArray(imagesArray)) return []
  const seen = new Map()
  imagesArray.forEach((img) => {
    if (!img) return
    const key = getCanonicalKey(img)
    // Keep the first one we encounter
    if (!seen.has(key)) {
      seen.set(key, img)
    }
  })
  return Array.from(seen.values())
}

export default function GalleryPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  const categoryParam = searchParams.get('kategori') || searchParams.get('category') || 'all'
  
  const [galleries, setGalleries] = useState([])
  const [selectedCategory, setSelectedCategory] = useState(categoryParam)
  const [loading, setLoading] = useState(true)

  // Sync state with URL search params
  useEffect(() => {
    if (categoryParam !== selectedCategory) {
      setSelectedCategory(categoryParam)
    }
  }, [categoryParam])

  const handleCategoryChange = (catId) => {
    setSelectedCategory(catId)
    const newParams = new URLSearchParams(searchParams)
    if (catId === 'all') {
      newParams.delete('kategori')
      newParams.delete('category')
    } else {
      newParams.set('kategori', catId)
    }
    setSearchParams(newParams)
  }

  useEffect(() => {
    const fetchGalleries = async () => {
      try {
        const response = await fetch('https://api.dev.auxo.dk/public/content/galleries')
        if (response.ok) {
          const data = await response.json()
          setGalleries(data)
        }
      } catch (err) {
        console.error('Error fetching galleries:', err)
      } finally {
        setLoading(false)
      }
    }
    fetchGalleries()
  }, [])

  useEffect(() => {
    document.title = 'Billedgalleri & Før/Efter | Malerfirmaet Villy Poulsen'
    const metaDescriptionTag = document.querySelector('meta[name="description"]')
    if (metaDescriptionTag) {
      metaDescriptionTag.setAttribute(
        'content',
        'Se billeder af vores professionelle malerarbejde, sprøjtemaling og før/efter resultater udført i Østjylland.'
      )
    }
  }, [])

  // Get all unique images across all galleries and asset library
  const getFilteredImages = () => {
    let combined = []

    if (selectedCategory === 'all') {
      combined = [...ALL_ASSET_IMAGES]

      // Merge CMS images
      galleries.forEach((gallery) => {
        if (gallery.images && Array.isArray(gallery.images)) {
          gallery.images.forEach((img) => {
            combined.push(img)
          })
        }
      })
    } else {
      // Find the CMS gallery matching the selected category
      const selectedGallery = galleries.find(
        (g) => (g.gallery_slug?.trim().toLowerCase() === selectedCategory?.trim().toLowerCase()) || g.id === selectedCategory
      )

      if (selectedGallery) {
        const cmsImages = selectedGallery.images || []

        // If it's sprøjtemaling, merge the hardcoded sprøjtemaling images for completeness
        if (selectedCategory === 'sproejtemaling') {
          const hardcodedSproejte = []
          combined = [...hardcodedSproejte, ...cmsImages]
        } else {
          combined = [...cmsImages]
        }
      }
    }

    // Apply strict deduplication based on canonical filenames
    return deduplicateImages(combined.filter(Boolean))
  }

  const getSelectedCategoryDescription = () => {
    if (selectedCategory === 'all') {
      return 'Her kan du se alle vores billeder på tværs af alle vores arbejdsområder.'
    }
    const selectedGallery = galleries.find(
      (g) => (g.gallery_slug?.trim().toLowerCase() === selectedCategory?.trim().toLowerCase()) || g.id === selectedCategory
    )
    return selectedGallery?.description?.da || selectedGallery?.description || ''
  }

  // Generate categories dynamically from CMS galleries
  const categories = [
    { id: 'all', label: 'Vis alle billeder' },
    { id: 'before-after', label: 'Før & Efter' },
    ...galleries.map((g) => ({
      id: g.gallery_slug?.trim().toLowerCase() || g.id,
      label: g.title?.da || g.title || 'Galleri'
    }))
  ]

  return (
    <div className="bg-white">
      {/* Page Header */}
      <section className="relative bg-gray-900 text-white py-24">
        <div className="absolute inset-0 z-0">
          <img
            src="https://assets.auxodev.dk/assets/bbcf0f14-2bcd-4cd4-98b4-2d62ce00d60f/7ad70890-421f-4462-9be6-ff81da2bda37.jpeg"
            alt="Billedgalleri"
            className="w-full h-full object-cover opacity-45"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-950/80 via-gray-900/50 to-transparent" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-[#FDF300] bg-[#FDF300]/10 px-3 py-1.5 rounded-full">
            Se vores arbejde
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black mt-4">
            Billedgalleri & Resultater
          </h1>
          <p className="text-gray-300 text-sm sm:text-base mt-3 max-w-2xl mx-auto leading-relaxed">
            Gennemse vores store galleri af udført arbejde. Se vores flotte før/efter resultater og lad dig inspirere til dit næste malerprojekt.
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Intro Text */}
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-black text-gray-900 mb-4">Udforsk Vores Håndværk</h2>
            <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
              Her kan du se et bredt udvalg af vores udførte malerarbejde. Se alle billeder samlet ét sted, eller prøv vores interaktive <strong>Før & Efter</strong> fane for at se den fantastiske forvandling med egne øjne.
            </p>
          </div>

          {loading ? (
            <div className="flex justify-center py-20">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#01529E]" />
            </div>
          ) : (
            <div className="space-y-12">
              {/* Category Filter Buttons */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 max-w-4xl mx-auto border-b border-gray-100 pb-8">
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => handleCategoryChange(cat.id)}
                    className={`px-3 py-2.5 rounded-xl text-xs sm:text-sm font-bold tracking-wide transition-all cursor-pointer text-center ${
                      selectedCategory === cat.id
                        ? 'bg-[#01529E] text-white shadow-md'
                        : 'bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                    }`}
                  >
                    {cat.label}
                  </button>
                ))}
              </div>

              {/* Render Before & After Sliders */}
              {selectedCategory === 'before-after' ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
                  {BEFORE_AFTER_PAIRS.map((pair) => (
                    <BeforeAfterSlider
                      key={pair.id}
                      title={pair.title}
                      description={pair.description}
                      before={pair.before}
                      after={pair.after}
                      beforeLabel={pair.beforeLabel}
                      afterLabel={pair.afterLabel}
                    />
                  ))}
                </div>
              ) : (
                /* Lightbox Gallery Grid for standard categories */
                <LightboxGallery
                  images={getFilteredImages()}
                  title={categories.find((c) => c.id === selectedCategory)?.label}
                  description={getSelectedCategoryDescription()}
                />
              )}
            </div>
          )}
        </div>
      </section>

      {/* Call to Action Banner */}
      <section className="bg-gray-50 py-16 border-t border-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-xl sm:text-2xl font-black text-gray-900 mb-3">
            Inspireret til dit eget projekt?
          </h3>
          <p className="text-gray-600 text-sm sm:text-base max-w-xl mx-auto mb-8">
            Uanset om du skal have malet stuen, facaden eller sprøjtemalet dine døre, står vi klar til at levere et perfekt resultat.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href="tel:40637670"
              className="px-6 py-3 rounded-xl bg-white text-gray-900 font-bold text-sm shadow-sm border border-gray-200 hover:bg-gray-50 transition-all flex items-center justify-center gap-2"
            >
              Ring 40 63 76 70
            </a>
            <a
              href="/kontakt"
              className="px-6 py-3 rounded-xl bg-[#ED1C26] text-white font-bold text-sm shadow-md hover:bg-[#ED1C26]/90 transition-all flex items-center justify-center gap-2 cursor-pointer"
            >
              Få et uforpligtende tilbud
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}
